var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-pin_svg__logo-pin_svg__Canvas",
    transform: "translate(10682 -3212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-pin_svg__logo-pin_svg__Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-pin_svg__logo-pin_svg__Oval_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-pin_svg__logo-pin_svg__path0_fill",
    transform: "matrix(1 0 0 1 -10682 3212)",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-pin_svg__logo-pin_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-pin_svg__logo-pin_svg__path1_fill",
    transform: "translate(-10664.6 3225.99)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-pin_svg__logo-pin_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-pin_svg__logo-pin_svg__path2_fill",
    transform: "translate(-10660.8 3239.21)",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-pin_svg__logo-pin_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 25 50C 38.8071 50 50 38.8071 50 25C 50 11.1929 38.8071 0 25 0C 11.1929 0 0 11.1929 0 25C 0 38.8071 11.1929 50 25 50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-pin_svg__logo-pin_svg__path1_fill",
    d: "M 16.3158 14.6399C 16.188 12.6416 15.3699 10.7446 14.0661 9.25222C 13.7593 8.89811 13.4014 8.54399 13.0435 8.24046L 16.2391 3.3587C 16.3669 3.18165 16.2647 2.9287 16.0601 2.87811L 7.44472 0.0198822C 7.2402 -0.0560001 7.03568 0.0957583 7.01012 0.298111L 6.60108 6.09046C 6.11535 6.11576 5.62962 6.19164 5.16945 6.29281C 3.22651 6.69752 1.43694 7.73458 0.107563 9.25222C -0.0969568 9.47987 0.00530634 9.83399 0.286521 9.93517L 15.8045 15.0699C 16.0346 15.171 16.3413 14.9434 16.3158 14.6399Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-pin_svg__logo-pin_svg__path2_fill",
    d: "M 0.0083089 10.1682C -0.0939511 10.8006 0.775262 11.1041 1.08204 10.5224L 5.8627 1.34059L 1.7723 3.08766e-06L 0.0083089 10.1682Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPin);
export default __webpack_public_path__ + "static/media/logo-pin.946256b2377fb9a97a017862f1de02d3.svg";
export { ForwardRef as ReactComponent };